import React, { useEffect, useState } from "react";
 
import Swal from "sweetalert2";
import hotel from "../../../component/img/hotel.png";
import flight from "../../../component/img/flight.jpg";
import bus from "../../../component/img/bus.jpg";
import dth from "../../../component/img/dth.png";
import { Link } from "react-router-dom";

function NavbarVisitorTwo({   }) {
  

  return (
    <>

    <div className="bg-light">
    <div className="d-flex justify-content-center align-items-center my-2">
  <div className="d-flex align-items-center me-4 ">
    <Link to="/flight-search-visitor" className="nmbaz1">
    <img src={flight} className="img-fluid nmbaz"/>&nbsp;Flight
    </Link> 
  </div>


  <div className="d-flex align-items-center me-4  ">
  <Link to="/search-hotel" className="nmbaz1">
  <img src={hotel} className="img-fluid nmbaz"/>&nbsp;Hotels
  </Link> 
  </div>


  <div className="d-flex align-items-center me-4  ">
  <Link to="/bus-search" className="nmbaz1">
  <img src={bus} className="img-fluid nmbaz"/>&nbsp;Bus
  </Link> 
  </div>

  <div className="d-flex align-items-center me-4  ">
  <Link className="nmbaz1">
  <img src={dth} className="img-fluid nmbaz"/>&nbsp;DTH Recharge
  </Link> 
  </div>
</div>
    </div>
    
    

    </>
  );
}

export default NavbarVisitorTwo;